import { createReducer } from './utils'

export default createReducer({
    'LOAD_REGION': (state, action) => {
        return {
            loading: true,
            regions: {
                ...state.regions,
                [action.regionName]: state.data || {}
            },
        }
    },

    'LOADED_REGION': (state, action) => {
        return {
            loading: false,
            regions: {
                ...state.regions,
                [action.regionName]: action.regionData
            }
        }
    },
    'LOAD_COLLECTION': (state, action) => {
        return {
            ...state,
            collections: {
                [action.name]: null
            },
        }
    },

    'LOADED_COLLECTION': (state, action) => {
        return {
            ...state,
            collections: {
                [action.name]: action.data
            },
        }
    }
}, {
    loading: true,
    regions: {},
    collections: {}
})


// WEBPACK FOOTER //
// ./src/reducers/content.js